export default __webpack_public_path__ + "static/media/icon-application-evaluation.81fd33e4.svg";